export { default } from '@triptyk/ember-utils/utils/window-history-back';
